export default __webpack_public_path__ + "static/media/apple-store-badge.b84d4a17.svg";